"use strict";

$.fn.setDatatableAdmin = function (settings) {
    var $container = $(this),
        $table = $container.find("table:first"),
        setting = {
        dom: $container.data("dom") || 'f<"clear">rt<"bottom w-100 text-center"pl>i<"clear">',
        language: {
            processing: "<i class=\"fa fa-spinner fa-spin fa-5x\"></i>"
        },
        inlineEdit: {
            enabled: true
        }
    };
    if (settings) {
        setting = $.extend(setting, settings);
    }
    var datatable = $table.DataTable(setting);
    // Filtre sur la colonne indiquée par l'attribut select
    $(".datatable-admin-filter-select", $container).on("change", function () {
        var $filter = $(this),
            columnName = $filter.data("column"),
            columnIndex = $table.find("th[data-column=" + columnName + "]").index();
        var value = $filter.val();
        datatable.column(columnIndex).search(value).draw();
    });
    // Bouton pour retirer les filtres
    $(".btn-select-unfilter", $container).on("click", function () {
        datatable.columns().each(function () {
            this.search("").draw();
            // Reset des select
            $(".datatable-admin-filter-select").find("option:eq(0)").prop("selected", true);
        });
    });
    $container.data("datatable", datatable).data("datas", datatable.data());
    return $table;
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Datatable/initDatatableAdmin.ts
// module id = 522
// module chunks = 0